import { useTranslation } from 'react-i18next'
import { LogOut } from 'lucide-react'
import { Button } from '../ui/button'
import { useAdminStore } from '../../stores/adminStore'

export const IMPERSONATION_BANNER_HEIGHT = 'h-10'
export const IMPERSONATION_BANNER_TOP = 'top-10'

export function ImpersonationBanner() {
  const { t } = useTranslation()
  const isImpersonating = useAdminStore((s) => s.isImpersonating)
  const impersonatedUser = useAdminStore((s) => s.impersonatedUser)
  const stopImpersonation = useAdminStore((s) => s.stopImpersonation)

  if (!isImpersonating || !impersonatedUser) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-10 bg-amber-500 text-amber-950 px-4 flex items-center justify-center text-sm font-medium">
      <span>
        {t('admin.impersonation.workingAs', { name: impersonatedUser.name })}
      </span>
      <Button
        variant="ghost"
        size="sm"
        className="absolute right-2 h-7 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
        onClick={() => stopImpersonation()}
      >
        <LogOut className="h-3.5 w-3.5 mr-1" />
        {t('admin.impersonation.exit')}
      </Button>
    </div>
  )
}

export function useImpersonationOffset() {
  const isImpersonating = useAdminStore((s) => s.isImpersonating)
  return isImpersonating
}
